import type { CacheStore } from '@inter-ikea-kompis/utilities';
import { GlobalCacheStore } from '@inter-ikea-kompis/utilities';

import type IKeyboard from './types/IKeyboard.js';

/**
 * Keyboard manager.
 */
export default class KeyboardManager {
	private cache: Map<string, Set<IKeyboard>>;

	/**
	 * Constructor.
	 *
	 * @param [cacheStore] Cache store.
	 */
	constructor(cacheStore: CacheStore = new GlobalCacheStore()) {
		this.cache = cacheStore.getStore('keyboardManager');
	}

	/**
	 * Adds a keyboard.
	 *
	 * @param keyboard Keyboard.
	 */
	public addKeyboard(keyboard: IKeyboard): void {
		this.getKeyboards().add(keyboard);
	}

	/**
	 * @param keyboard Keyboard.
	 *
	 * Removes the keyboard.
	 */
	public removeKeyboard(keyboard: IKeyboard): void {
		this.getKeyboards().delete(keyboard);
	}

	/**
	 * Show keyboard.
	 *
	 * @param inputElement Input Element.
	 */
	public setFocus(inputElement: HTMLInputElement): void {
		this.getKeyboards().forEach((keyboard) => keyboard.setFocus(inputElement));
	}

	/**
	 * Hides the keyboard.
	 *
	 */
	public removeFocus(): void {
		this.getKeyboards().forEach((keyboard) => keyboard.removeFocus());
	}

	/**
	 * Gets keyboards from cache store.
	 *
	 * @returns Keyboard set.
	 */
	public getKeyboards(): Set<IKeyboard> {
		const keyboards = this.cache.get('keyboards');
		if (keyboards) {
			return keyboards;
		}
		this.cache.set('keyboards', new Set());
		return <Set<IKeyboard>>this.cache.get('keyboards');
	}
}
